import { getOS } from '@nzyme/dom-utils/getOs.js';
import { isProbablyMobile } from '@nzyme/dom-utils/isProbablyMobile.js';
import { createEventEmitter } from '@nzyme/utils/createEventEmitter.js';
import { onWindowEvent } from '@nzyme/vue-utils/onWindowEvent.js';
export function useShortcut(shortcut) {
    const { emitAsync, event } = createEventEmitter();
    if (isProbablyMobile()) {
        return undefined;
    }
    // There are no shortcuts on mobile devices
    onWindowEvent('keydown', async (keyboardEvent) => {
        if (keyboardEvent.isComposing) {
            return;
        }
        if (isShortcutMatch(keyboardEvent, shortcut)) {
            keyboardEvent.preventDefault();
            keyboardEvent.stopPropagation();
            await emitAsync(keyboardEvent);
        }
    });
    return {
        ...shortcut,
        event,
    };
}
export function isShortcutMatch(event, shortcut) {
    const isMacOS = getOS() === 'macOS';
    const defaultModifier = isMacOS ? 'metaKey' : 'ctrlKey';
    const cmdMatches = shortcut.cmd ? event[defaultModifier] : !event[defaultModifier];
    const ctrlMatches = shortcut.ctrl ? event.ctrlKey : !event.ctrlKey;
    const shiftMatches = shortcut.shift ? event.shiftKey : !event.shiftKey;
    return shortcut.key === event.key && cmdMatches && ctrlMatches && shiftMatches;
}
//# sourceMappingURL=useShortcut.js.map